export const LAST_INPUT_ID = '3';
export const FIRST_INPUT_ID = '0';
export const CODE_LENGTH = 4;
export const MIN_LENGTH = 1;
